


// Custom Project Slider Js

// $(".custom-projects-slider").slick({
//   dots: false,
//   infinite: false,
//   speed: 500,
//   arrows: true,
//   slidesToShow: 2.1,
//   slidesToScroll: 1,
//   prevArrow:
//     '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none"><path d="M1.79291 14.219C3.24226 8.04951 8.06145 3.23355 14.2319 1.78834C18.6882 0.744621 23.3255 0.746176 27.781 1.79288C33.9505 3.24223 38.7665 8.06142 40.2117 14.2319C41.2554 18.6881 41.2538 23.3254 40.2071 27.781C38.7578 33.9505 33.9386 38.7665 27.7681 40.2117C23.3119 41.2554 18.6746 41.2538 14.219 40.2071C8.04955 38.7578 3.23358 33.9386 1.78837 27.7681C0.744646 23.3119 0.746201 18.6746 1.79291 14.219Z" stroke="#181818"/><path d="M13.2252 20.9967L28.7755 21.0019M28.7755 21.0019L23.2237 15.4463M28.7755 21.0019L23.22 26.5537" stroke="#181818" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//   nextArrow:
//     '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none"><path d="M1.79291 14.219C3.24226 8.04951 8.06145 3.23355 14.2319 1.78834C18.6882 0.744621 23.3255 0.746176 27.781 1.79288C33.9505 3.24223 38.7665 8.06142 40.2117 14.2319C41.2554 18.6881 41.2538 23.3254 40.2071 27.781C38.7578 33.9505 33.9386 38.7665 27.7681 40.2117C23.3119 41.2554 18.6746 41.2538 14.219 40.2071C8.04955 38.7578 3.23358 33.9386 1.78837 27.7681C0.744646 23.3119 0.746201 18.6746 1.79291 14.219Z" stroke="#181818"/><path d="M13.2252 20.9967L28.7755 21.0019M28.7755 21.0019L23.2237 15.4463M28.7755 21.0019L23.22 26.5537" stroke="#181818" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//   responsive: [
//     {
//       breakpoint: 1080,
//       settings: {},
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 1.1,
//       },
//     },
//   ],
// });

// Services Image dynamic Height

if (window.matchMedia('(min-width: 767px)').matches) {
  document.addEventListener("DOMContentLoaded", function() {
    function setRightContainerHeight() {
      let leftContainer = document.getElementById('left-container');
      let leftContainerHeight = leftContainer.offsetHeight;
  
      let totalTextBlocksHeight = 0;
      let textBlocks = document.querySelectorAll('.single-row');
      textBlocks.forEach(function(block) {
        totalTextBlocksHeight += block.offsetHeight;
      });
  
      let rightContainer = document.querySelector('.right-container');
      let rightImgBox = document.querySelector('.right-img-box');
      let maxheight = Math.max(leftContainerHeight, totalTextBlocksHeight);
      rightContainer.style.height = maxheight + 'px';
      rightImgBox.style.height = maxheight + 'px';
    }
  
    setRightContainerHeight();
  
    window.addEventListener('resize', setRightContainerHeight);
  });
}


// const projectSlider = $(".custom-projects-slider");
// projectSlider
//   .slick({
//     dots: false,
//   infinite: false,
//   speed: 500,
//   arrows: true,
//   slidesToShow: 2.1,
//   slidesToScroll: 1,
//   prevArrow:
//     '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none"><path d="M1.79291 14.219C3.24226 8.04951 8.06145 3.23355 14.2319 1.78834C18.6882 0.744621 23.3255 0.746176 27.781 1.79288C33.9505 3.24223 38.7665 8.06142 40.2117 14.2319C41.2554 18.6881 41.2538 23.3254 40.2071 27.781C38.7578 33.9505 33.9386 38.7665 27.7681 40.2117C23.3119 41.2554 18.6746 41.2538 14.219 40.2071C8.04955 38.7578 3.23358 33.9386 1.78837 27.7681C0.744646 23.3119 0.746201 18.6746 1.79291 14.219Z" stroke="#181818"/><path d="M13.2252 20.9967L28.7755 21.0019M28.7755 21.0019L23.2237 15.4463M28.7755 21.0019L23.22 26.5537" stroke="#181818" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//   nextArrow:
//     '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none"><path d="M1.79291 14.219C3.24226 8.04951 8.06145 3.23355 14.2319 1.78834C18.6882 0.744621 23.3255 0.746176 27.781 1.79288C33.9505 3.24223 38.7665 8.06142 40.2117 14.2319C41.2554 18.6881 41.2538 23.3254 40.2071 27.781C38.7578 33.9505 33.9386 38.7665 27.7681 40.2117C23.3119 41.2554 18.6746 41.2538 14.219 40.2071C8.04955 38.7578 3.23358 33.9386 1.78837 27.7681C0.744646 23.3119 0.746201 18.6746 1.79291 14.219Z" stroke="#181818"/><path d="M13.2252 20.9967L28.7755 21.0019M28.7755 21.0019L23.2237 15.4463M28.7755 21.0019L23.22 26.5537" stroke="#181818" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//   responsive: [
//     {
//       breakpoint: 1080,
//       settings: {},
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 1.1,
//       },
//     },
//   ],
//   });

// projectSlider.on('wheel', (function(e) {
//   e.preventDefault();

//   if (e.originalEvent.deltaY < 0) {
//     $(this).slick('slickPrev');
//   } else {
//     $(this).slick('slickNext');
//   }
// }));
  

// Custom Testimonials Slider Js

$(".custom-testimoniasl-slider").slick({
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 700,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

// Video Gallery Js

document.addEventListener("DOMContentLoaded", function () {
  var videoContainers = document.querySelectorAll(".custom-video-container");

  videoContainers.forEach(function (videoContainer) {
    var video = videoContainer.querySelector(".customVideo");
    var playPauseBtn = videoContainer.querySelector(".playPauseBtn");

    playPauseBtn.addEventListener("click", function (event) {
      event.stopPropagation();
      togglePlayPause(video, playPauseBtn);
    });

    videoContainer.addEventListener("click", function () {
      togglePlayPause(video, playPauseBtn);
    });

    video.addEventListener("play", function () {
      playPauseBtn.classList.remove("play");
      playPauseBtn.classList.add("pause");
    });

    video.addEventListener("pause", function () {
      playPauseBtn.classList.remove("pause");
      playPauseBtn.classList.add("play");
    });
  });

  function togglePlayPause(video, playPauseBtn) {
    if (video.paused || video.ended) {
      video.play();
      playPauseBtn.classList.remove("play");
      playPauseBtn.classList.add("pause");
    } else {
      video.pause();
      playPauseBtn.classList.remove("pause");
      playPauseBtn.classList.add("play");
    }
  }
});

// Services Scrolling animation trigger js

// document.addEventListener("DOMContentLoaded", function () {
//   let headings = document.querySelectorAll(
//     ".scrolling-trigger-text-blocks-container .text-block .heading"
//   );
//   let verticalLine = document.querySelector(".vertical-line");
//   let maxLineHeight = 0;

//   function isElementAtBottom(el) {
//     let rect = el.getBoundingClientRect();
//     let triggerHeight = window.innerWidth > 767 ? window.innerHeight : window.innerHeight * 0.85;
//     return rect.bottom <= triggerHeight && rect.bottom > 0;
//   }

//   function handleScroll() {
//     let found = false;

//     headings.forEach(function (heading) {
//       heading.classList.remove("revealed");

//       if (!found && isElementAtBottom(heading)) {
//         heading.classList.add("any-heading-revealed");

//         let scrollY = window.scrollY || window.pageYOffset;
//         let viewportHeight = window.innerHeight;
//         let contentHeight =
//           document.documentElement.scrollHeight - viewportHeight;

//         let sectionHeight = document.querySelector(
//           ".scrolling-trigger-text-blocks-section"
//         ).offsetHeight;
//         let sectionTop = document.querySelector(
//           ".scrolling-trigger-text-blocks-section"
//         ).offsetTop;

//         let sectionEnd = sectionTop + sectionHeight;

//         let verticalLineHeight = Math.max(
//           0,
//           Math.min(
//             scrollY + viewportHeight / 2 - sectionTop - 50,
//             sectionHeight
//           )
//         );

//         if (verticalLineHeight > maxLineHeight) {
//           maxLineHeight = verticalLineHeight;
//           verticalLine.style.height = maxLineHeight + "px";
//           heading.classList.add("revealed");
//         }

//         found = true;
//       } else {
//         heading.classList.remove("revealed");
//       }
//     });
//   }

//   handleScroll();

//   window.addEventListener("scroll", function () {
//     handleScroll();
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  let headings = document.querySelectorAll(
    ".scrolling-trigger-text-blocks-container .text-block .heading"
  );
  let verticalLine = document.querySelector(".vertical-line");
  let maxLineHeight = 0;

  // function isElementInViewport(el) {
  //   let rect = el.getBoundingClientRect();
  //   let triggerHeight = window.innerWidth > 767 ? window.innerHeight : window.innerHeight * 0.85;
  //   return (
  //     rect.bottom >= 0 &&
  //     rect.top <= (window.innerHeight || document.documentElement.clientHeight)
  //   );
  // }
  function isElementInViewport(el) {
  let rect = el.getBoundingClientRect();
  let triggerHeight = window.innerWidth > 767 ? window.innerHeight : window.innerHeight * 0.85;

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// function handleScroll() {
//   let found = false;

//   headings.forEach(function (heading) {
//     heading.classList.remove("revealed");

//     if (!found && isElementInViewport(heading)) {
//       heading.classList.add("any-heading-revealed");

//       let scrollY = window.scrollY || window.pageYOffset;

//       let viewportHeight = window.innerHeight;

//       let sectionHeight = document.querySelector(".scrolling-trigger-text-blocks-section").offsetHeight;
//       let sectionTop = document.querySelector(".scrolling-trigger-text-blocks-section").offsetTop;
//       let verticalLineHeight = Math.max(0,Math.min(scrollY + viewportHeight / 2 - sectionTop - 50,sectionHeight));
//       let heightDifference = sectionHeight;
//       if (heightDifference !== 0 ) {
//         verticalLineHeight = verticalLineHeight + 150;
//         verticalLine.style.height = verticalLineHeight + "px";
//         // maxLineHeight = verticalLineHeight;

//         heading.classList.add("revealed");
//       }

//       found = true;
//     } else {
//    heading.classList.remove("revealed");
//   found = false; 
//     }
//   });
// }
function handleScroll() {
  headings.forEach(function (heading) {
    let isHeadingInViewport = isElementInViewport(heading);

    if (isHeadingInViewport) {
      
      let scrollY = window.scrollY || window.pageYOffset;
      let viewportHeight = window.innerHeight;
      let sectionHeight = document.querySelector(".scrolling-trigger-text-blocks-section").offsetHeight;
      let sectionTop = document.querySelector(".scrolling-trigger-text-blocks-section").offsetTop;
      let verticalLineHeight = Math.max(0, Math.min(scrollY + viewportHeight / 2 - sectionTop - 50, sectionHeight));
      let heightDifference = sectionHeight;
      
    heading.classList.add("any-heading-revealed");


      if (heightDifference ) {
        verticalLineHeight = verticalLineHeight + 150;
        
        var loopElements = document.querySelectorAll('.text-block');
        var specificElement = document.querySelectorAll('.vertical-line')[0];
   
        console.log(`specificElement ${specificElement.offsetHeight}`);
        loopElements.forEach(function(element, index) {
        var topOffset = element.offsetTop;
        let iselementInViewport = isElementInViewport(element);

        if (iselementInViewport) {
        verticalLine.style.height = topOffset + "px";
          
        }

      });
        heading.classList.add("revealed");
        
      } else {
        heading.classList.remove("revealed");
      }
    } else {
      heading.classList.remove("revealed");
    }
  });
}

  handleScroll();

  window.addEventListener("scroll", function () {
    handleScroll();

  });

});

document.addEventListener("DOMContentLoaded", function () {
  const footerLinks = document.querySelectorAll("footer a[href^='#section']");

  footerLinks.forEach(link => {
    link.addEventListener("click", event => {
      event.preventDefault();

      const targetSectionId = link.getAttribute("href");
      const isServicesPageOpen = window.location.href.includes("mejor-group.com/pages/services");

      const scrollToTargetSection = () => {
        const targetSection = document.querySelector(targetSectionId);
        let targetScrollPosition = 0;

        if (targetSection) {
          targetScrollPosition = targetSection.getBoundingClientRect().top + window.scrollY;
        }

        window.scrollTo({
          top: targetScrollPosition,
          behavior: "smooth"
        });
      };

      if (!isServicesPageOpen) {
        window.location.href = "https://www.mejor-group.com/pages/services?section=" + targetSectionId;
      } else {
        scrollToTargetSection();
      }
    });
  });
});




